import { FC, ReactChild, ReactFragment } from 'react';
import { Tooltip, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import HelpIcon from '@mui/icons-material/HelpOutlineOutlined';

const useStyles = makeStyles()(() => ({
  helpText: {
    fontSize: '0.825rem',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: 400,
  },
}));

interface HelpTooltipProps {
  title?: ReactChild | ReactFragment;
  body: ReactChild | ReactFragment;
  iconStyle?: Record<string, unknown>;
}

// Shows tooltip over a question mark icon, using larger text than default.
export const HelpTooltip: FC<React.PropsWithChildren<HelpTooltipProps>> = ({
  title,
  body,
  iconStyle,
}) => {
  const { classes } = useStyles();
  return (
    <Tooltip
      title={
        <>
          {title && (
            <>
              <Typography color="inherit">{title}</Typography>
              <br />
            </>
          )}

          <span className={classes.helpText}>{body}</span>
          <br />
        </>
      }
    >
      <HelpIcon style={iconStyle}></HelpIcon>
    </Tooltip>
  );
};
